import React from "react";

const PropertyTypes = () => {
  const propertyTypes = [
    {
      id: 1,
      name: "Residential",
      description: "Houses, Apartments, Villas",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
      count: "2,500+",
      color: "bg-blue-50 text-blue-600 border-blue-200"
    },
    {
      id: 2,
      name: "Commercial",
      description: "Offices, Retail Spaces",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 8v-5m0 5h4" />
        </svg>
      ),
      count: "850+",
      color: "bg-green-50 text-green-600 border-green-200"
    },
    {
      id: 3,
      name: "Industrial",
      description: "Warehouses, Factories",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      ),
      count: "320+",
      color: "bg-orange-50 text-orange-600 border-orange-200"
    },
    {
      id: 4,
      name: "Land",
      description: "Plots, Agricultural Land",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      count: "1,200+",
      color: "bg-purple-50 text-purple-600 border-purple-200"
    },
    {
      id: 5,
      name: "Luxury",
      description: "Premium Properties",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
        </svg>
      ),
      count: "180+",
      color: "bg-red-50 text-red-600 border-red-200"
    },
    {
      id: 6,
      name: "Vacation",
      description: "Holiday Homes, Resorts",
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      count: "450+",
      color: "bg-teal-50 text-teal-600 border-teal-200"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Explore Property Types
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover a wide range of properties tailored to meet your specific needs and preferences
          </p>
          <div className="w-20 h-1 bg-green-500 mx-auto mt-6 rounded-full"></div>
        </div>

        {/* Property Types Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {propertyTypes.map((property) => (
            <div
              key={property.id}
              className={`group relative bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border-2 ${property.color.split(' ')[2]} overflow-hidden`}
            >
              <div className="p-6">
                {/* Icon and Header */}
                <div className="flex items-center mb-4">
                  <div className={`p-3 rounded-lg ${property.color.split(' ')[0]} mr-4 group-hover:scale-110 transition-transform duration-300`}>
                    {property.icon}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">{property.name}</h3>
                    <span className={`text-sm font-medium ${property.color.split(' ')[1]}`}>
                      {property.count} Properties
                    </span>
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-600 mb-4">{property.description}</p>

                {/* Explore Button */}
                <button className={`w-full py-2 px-4 rounded-lg font-medium transition-all duration-300 border-2 ${property.color.split(' ')[2]} bg-white hover:bg-gradient-to-r hover:from-green-500 hover:to-green-600 hover:text-white hover:border-transparent group-hover:shadow-md`}>
                  Explore {property.name}
                </button>
              </div>

              {/* Hover Effect Background */}
              <div className={`absolute inset-0 bg-gradient-to-br ${property.color.split(' ')[0]} opacity-0 group-hover:opacity-5 transition-opacity duration-300`}></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <div className="bg-white rounded-lg shadow-md p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Can't Find What You're Looking For?
            </h3>
            <p className="text-gray-600 mb-6">
              Our expert agents will help you find the perfect property that matches your requirements
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-300 shadow-md hover:shadow-lg">
                Contact an Agent
              </button>
              <button className="border-2 border-green-500 text-green-500 hover:bg-green-500 hover:text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300">
                Schedule a Tour
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyTypes;